@if (showLoader) {
  <div>
    <h1 mat-dialog-title class="dialog-title">
      <mat-icon color="primary">info</mat-icon>
      <b class="dialog-title-content">{{ categoryTitle | translate }}</b>
    </h1>
    <glxy-loading-spinner size="large" [fullWidth]="true" [fullHeight]="true" [inline]="false" />
  </div>
}

@if (!showLoader && allowEntityDeletion) {
  <div>
    <h1 mat-dialog-title class="dialog-title">
      <mat-icon color="primary">info</mat-icon>
      <b class="dialog-title-content">{{ categoryTitle | translate }}</b>
    </h1>
    @if (!showLoader && allowEntityDeletion) {
      <div mat-dialog-content class="dialog-content">
        <p class="dialog-content">
          {{ categoryContent | translate }}
        </p>
      </div>
    }
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="onNoClick()">
        {{ categoryDoNotDelete | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="onYesClick()" cdkFocusInitial [disabled]="working">
        <span [ngClass]="{ loading: working }">
          {{ categoryDoDelete | translate }}
        </span>
        @if (working) {
          <div class="spinner-container">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        }
      </button>
    </mat-dialog-actions>
  </div>
}

@if (!showLoader && !allowEntityDeletion) {
  <div>
    <h1 mat-dialog-title class="dialog-title">
      <mat-icon color="warn">warning</mat-icon>
      <b class="dialog-title-content">{{ categoryTitle | translate }}</b>
    </h1>
    <div mat-dialog-content class="dialog-content">
      <p>{{ categoryContent | translate }}</p>
      <br />
      @if (service) {
        <div>
          <b>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.SERVICE.CANNOT_DELETE.HEADER' | translate: { count: service.length } }}
          </b>
          <p>{{ service.join(', ') }}.</p>
        </div>
      }
      @if (group) {
        <div>
          <b> {{ 'MEETING_SCHEDULER.BOOKING_LINK.GROUP.CANNOT_DELETE.HEADER' | translate: { count: group.length } }} </b>
          <p>{{ group.join(', ') }}.</p>
        </div>
      }
    </div>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="onNoClick()">
        {{ categoryDoNotDelete | translate }}
      </button>
    </mat-dialog-actions>
  </div>
}
